import { render, staticRenderFns } from "./PageBody.vue?vue&type=template&id=004730c7&"
import script from "./PageBody.vue?vue&type=script&lang=js&"
export * from "./PageBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports